import {GetterTree} from "vuex";
import {TemplateParamsState} from "@/store/settings/template_params/types";
import {RootState} from "@/store/types";

export const getters: GetterTree<TemplateParamsState, RootState> = {
  templateParams: state => state.templateParams
}